import {remCalc} from '../../_utils'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {SFCC_ORDER_STATUS} from '../../../pages/account/constant'

export default {
    baseStyle: {
        itemContainer: {
            bg: 'transparent',
            w: {
                lg: 'auto',
                md: 'auto',
                sm: 'auto',
                base: 'auto',
            },
            height: 'auto',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            minWidth: {
                lg: remCalc(476),
                md: remCalc(150),
                sm: remCalc(150),
                base: remCalc(150),
            },
        },
        infoLabelContainer: {
            flexDir: 'row',
            gap: 'xxxsmall.base',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
        productLabel: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: remCalc(168),
            paddingY: remCalc(6),
            paddingX: remCalc(8),
            gap: remCalc(12),
            bg: 'background.light-blue',
        },
        discount: {
            flex: '1 0 0',
            color: 'text.secondary',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        flexContainer: {
            w: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            gap: {
                base: 'xsmall-1.base',
                md: 'xsmall-1.md',
                lg: 'xsmall-1.lg',
                xl: 'xsmall-1.xl',
            },
            position: 'relative',
            paddingY: {base: 'small.base', md: 'small.md', lg: 'medium.lg', xl: 'medium.xl'},
            // '&::after': {
            //     content: '""',
            //     position: 'absolute',
            //     left: {base: 0, lg: remCalc(24)},
            //     right: {base: 0, lg: remCalc(24)},
            //     bottom: 0,
            //     height: '1px',
            //     backgroundColor: 'border.light',
            //     border: 'none',
            // },
        },
        cartImage: {
            width: {
                lg: remCalc(200),
                base: remCalc(100),
            },
            height: {
                lg: remCalc(200),
                base: remCalc(100),
            },
            objectFit: 'cover',
            borderRadius: 'large-1',
            backgroundColor: 'background.base.under',
            mixBlendMode: 'multiply',
        },
        itemName: {
            flex: '1 0 0',
            color: 'foreground.neutral.default',
            textStyle: 'body-xxlarge',
            fontWeight: 'medium',
            fontFamily: 'heading',
            minWidth: remCalc(179),
        },
        removeIcon: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: {
                lg: 'center',
                md: 'flex-end',
                sm: 'flex-end',
                base: 'flex-end',
            },
            gap: remCalc(18),
        },
        detailContainer: {
            display: 'flex',
            w: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: {
                lg: 'xxsmall.lg',
                md: 'xxsmall.md',
                sm: 'xxsmall.sm',
                base: 'xxsmall.base',
            },
        },
        headerStack: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            alignSelf: 'stretch',
            gap: remCalc(20),
            paddingY: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        priceAndQuantityPickerContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: {base: 'flex-start', lg: 'center'},
            width: '100%',
            gap: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
        },
        quantityAndLowStockContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        // omniAndPrice: {
        //     display: 'flex',
        //     flexDir: 'column',
        //     justifyContent: 'flex-start',
        //     alignItems: 'flex-start',
        //     gap: 'xsmall.base',
        //     flexWrap: 'wrap',
        // },
        priceContainer: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                lg: 'xxxsmall.lg',
                md: 'xxxsmall.md',
                sm: 'xxxsmall.sm',
                base: 'xxxsmall.base',
            },
        },
        vatDetails: {
            display: 'flex',
            width: '100%',
            flexDir: 'row',
            justifyContent: {base: 'flex-start', lg: 'flex-end'},
            alignItems: 'center',
            gap: remCalc(10),
        },
        itemPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        omnibus: {
            display: 'flex',
            flexDir: {
                lg: 'row',
                md: 'column',
                sm: 'column',
                base: 'column',
            },
            textAlign: 'left',
            width: {
                lg: remCalc(154),
                md: remCalc(95),
                sm: remCalc(95),
                base: remCalc(95),
            },
            height: {
                lg: remCalc(14),
                md: remCalc(32),
                sm: remCalc(32),
                base: remCalc(32),
            },
            flexShrink: 0,
            gap: {
                lg: 'xxsmall.lg',
                md: 'xxsmall.md',
                sm: 'xxsmall.sm',
                base: 'xxsmall.base',
            },
        },
        suggestedPrice: {
            textAlign: 'left',
            textDecorationLine: 'line-through',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        suggestedText: {
            whiteSpace: 'nowrap',
            textAlign: 'left',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        vatText: {
            color: 'text.default',
            flex: '1 0 0',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        textQuantity: {
            color: 'text.default',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        quantSelContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
        },
        officinaLink: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: remCalc(10),
            color: 'text.tertiary',
            textStyle: 'body-small',
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        subAndSaveText: {
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
            color: 'foreground.neutral.default',
        },
        subAndSaveButton: {
            textStyle: 'body-small',
        },
        warrantyDesktopContainer: {
            display: {base: 'none', md: 'flex'},
            flexDirection: 'column',
            w: '100%',
            paddingTop: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        warrantyMobileContainer: {
            display: {base: 'flex', md: 'none'},
            flexDirection: 'column',
            w: '100%',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            marginBottom: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
        },
        warrantyTitleIconContainer: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: remCalc(8),
        },
        warrantyIcon: {
            width: remCalc(20),
            height: remCalc(20),
        },
        warrantyTitle: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        warrantyProtection: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.subtle',
        },
        warrantyButtonAccordion: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            justifyContent: 'flex-start',
            gap: remCalc(8),
        },
        warrantyAccordionItem: {
            paddingY: remCalc(16),
            paddingX: remCalc(0),
        },
        warrantyAccordionPanel: {
            marginTop: remCalc(0),
        },
        preorderCartContainer: {
            display: 'flex',
            w: {base: 'auto', lg: '100%'},
            justifyContent: {base: 'flex-start'},
            alignItems: 'baseline',
            flexShrink: {base: 1, lg: 0},
            flex: {base: '1 0 0', lg: 'none'},
            gap: {base: remCalc(8), lg: remCalc(2)},
        },
        preorderCartTitleText: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'text.default',
        },
        preorderCartDescriptionText: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
        },
        preorderCartDateText: {
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
            color: 'text.default',
        },
        backorderCartContainer: {
            display: 'flex',
            w: {base: 'auto', lg: '100%'},
            justifyContent: {base: 'flex-start'},
            alignItems: 'baseline',
            flexShrink: {base: 1, lg: 0},
            flex: {base: '1 0 0', lg: 'none'},
            gap: {base: remCalc(8), lg: remCalc(2)},
        },
        backorderCartTitleText: {
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'text.default',
        },
        backorderCartDescriptionText: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
        },
        backorderCartDateText: {
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
            color: 'text.default',
        },
        giftButtonIcon: {
            width: remCalc(16),
            height: remCalc(16),
        },
    },
    variants: {
        subscriptions: {
            omnibus: {
                width: 'fit-content',
                height: 'unset',
                flexDir: 'row',
                gap: remCalc(8),
            },
            detailContainer: {
                flexDir: 'column',
                gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            },
            innerContainer: {
                flexDir: 'column',
                width: '100%',
                alignItems: 'flex-start',
                gap: remCalc(20),
                paddingTop: {
                    base: 'xsmall.base',
                    md: 'xsmall.md',
                    lg: 'xsmall.lg',
                    xl: 'xsmall.xl',
                },
            },
            deleteOmniAndPrice: {
                width: '100%',
                flexDir: {base: 'column', lg: 'row'},
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                gap: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            },
            omniAndPrice: {
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
                flexDir: 'row',
                gap: remCalc(2),
            },
            price: {
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
                fontWeight: 'medium',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
            },
            monthlyText: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
                fontWeight: 'medium',
            },
            subscriptionDetailsContainer: {
                flexDir: 'column',
                gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
                paddingTop: {
                    base: 'xxsmall-1.base',
                    md: 'xxsmall-1.base',
                    lg: 'xxsmall-1.base',
                    xl: 'xxsmall-1.base',
                },
            },
            popoverContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(8),
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
            },
            discountDescriptionContainer: {
                textStyle: 'body-xsmall',
            },
            termsAndConditionsContainer: {
                flexDir: {base: 'column', lg: 'row'},
                gap: remCalc(4),
                alignItems: {base: 'flex-start', lg: 'center'},
                justifyContent: 'center',
            },
            termsAndConditionsText: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
                whiteSpace: 'nowrap',
            },
            termsAndConditionsLink: {
                whiteSpace: 'nowrap',
            },
        },
        subscriptionsMiniCart: {
            flexContainer: {
                gap: remCalc(9),
                pt: remCalc(16),
                pb: remCalc(16),
            },
            detailContainer: {
                gap: remCalc(8),
                width: remCalc(187),
            },
            cartImage: {
                width: remCalc(138),
                height: remCalc(138),
                objectFit: 'cover',
            },
            itemName: {
                color: 'text.default',
                fontSize: remCalc(18),
                lineHeight: remCalc(20),
                fontWeight: 'bold',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
                fontSize: remCalc(12),
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
            discountDescriptionContainer: {
                textStyle: 'body-xsmall',
            },
            omniAndPrice: {
                flexDir: 'row',
                gap: 0,
                alignItems: 'center',
            },
            omnibus: {
                w: 'fit-content',
                alignItems: 'center',
            },
        },
        subscriptionsOrderSummary: {
            cartImage: {
                width: remCalc(109),
                height: remCalc(109),
                objectFit: 'cover',
            },
            flexContainer: {
                gap: remCalc(16),
                pb: remCalc(0),
                backgroundColor: 'transparent',
                borderBottom: 'none',
            },
            detailContainer: {
                gap: remCalc(12),
            },
            itemName: {
                color: 'text.default',
                fontSize: remCalc(16),
                lineHeight: remCalc(20),
                fontWeight: 'bold',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
            },
            omnibus: {
                width: 'fit-content',
            },
            omniAndPrice: {
                fontSize: remCalc(12),
                flexDir: 'row',
                gap: 0,
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
        },
        subscriptionsConfirmation: {
            cartImage: {
                width: remCalc(109),
                height: remCalc(109),
                objectFit: 'cover',
            },
            flexContainer: {
                gap: remCalc(24),
            },
            detailContainer: {
                gap: remCalc(12),
            },
            itemName: {
                color: 'text.default',
                fontSize: remCalc(16),
                lineHeight: remCalc(20),
                fontWeight: 'normal',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
            },
            omnibus: {
                width: 'fit-content',
            },
            omniAndPrice: {
                fontSize: remCalc(16),
                flexDir: 'row',
                gap: 0,
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
        },
        OrderDetail: ({
            status,
            isMultipleShipment,
            isReturnOrderForm,
            isReturnOrder,
        }: {
            status: string
            isMultipleShipment: boolean
            isReturnOrderForm?: boolean
            isReturnOrder?: boolean
        }) => ({
            flexContainer: {
                gap: {
                    base: remCalc(12),
                    sm: remCalc(12),
                },
                paddingBottom: {base: remCalc(16), md: remCalc(24), lg: remCalc(24)},
                paddingTop: isReturnOrderForm
                    ? remCalc(24)
                    : isReturnOrder
                    ? {base: remCalc(32), md: remCalc(20), lg: remCalc(20)}
                    : {base: remCalc(32), md: remCalc(48), lg: remCalc(48)},
                paddingX: {base: remCalc(4), lg: 0},
                position: 'relative',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit',
                ...(isMultipleShipment
                    ? {
                          '&::after': {display: 'none'},
                          backgroundColor: 'inherit',
                      }
                    : {
                          '&:last-of-type': {
                              '&::after': {display: 'none'},
                              paddingBottom: {base: remCalc(32), md: remCalc(24), lg: remCalc(24)},
                          },
                      }),
            },
            detailContainer: {
                gap: {
                    base: remCalc(12),
                    sm: remCalc(12),
                },
                color:
                    status === SFCC_ORDER_STATUS.CANCELLED || status === SFCC_ORDER_STATUS.FAILED
                        ? 'text.secondary'
                        : 'text.default',
            },
            itemName: {
                color: 'inherit',
                alignSelf: 'stretch',
                maxWidth: remCalc(300),
                minWidth: 0,
            },
            itemCode: {
                textStyle: 'body-xsmall',
                color: 'text.secondary',
                fontWeight: 'normal',
            },
            textQuantity: {
                color: 'inherit',
            },
            vatDetails: {
                width: 'auto',
                color:
                    status === SFCC_ORDER_STATUS.CANCELLED || status === SFCC_ORDER_STATUS.FAILED
                        ? 'text.secondary'
                        : 'text.default',
            },
            productImage: {
                flexBasis: isReturnOrderForm
                    ? {base: remCalc(100), md: remCalc(120)}
                    : {base: remCalc(109), md: remCalc(212)},
                h: isReturnOrderForm
                    ? {base: remCalc(100), md: remCalc(120)}
                    : {base: remCalc(109), md: remCalc(212)},
                flexShrink: '0',
                alignSelf: isReturnOrderForm
                    ? 'flex-start'
                    : ['flex-start', 'flex-start', 'flex-start', 'unset'],
            },
            preorderLabel: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                color: 'text.default',
            },
            preorderBackorderLabel: {
                paddingTop: {base: remCalc(16), md: remCalc(24)},
                paddingLeft: {base: remCalc(16), md: remCalc(24)},
            },
        }),
    },
}
